// ---------------------------------------------------------------------------
// Block Definition: list (DocDsl)
//
// Bullet or numbered list.  Supports pre-defined item templates or free-form
// generation.  LLM generates list items from source.
// ---------------------------------------------------------------------------

function nullable(type, description, extra = {}) {
  const t = Array.isArray(type) ? type : [type, "null"];
  return { type: t, ...(description ? { description } : {}), ...extra };
}

export const listDef = {
  type: "list",
  label: "List",
  description: "Bullet or numbered list with inline formatting.",

  crystallizer: {
    extractionPhases: ["llm"],

    buildDataSchema(block, opts) {
      const style = block.style || "bullet";
      const items = block.items || [];
      const limit = block.item_limit || 10;
      const arrayDesc = [
        block.prompt || null,
        `Generate ${style} list items based on the source. Aim for up to ${limit} items.`
      ].filter(Boolean).join(" ");

      const itemProps = { text: nullable("string", "List item text. Use inline **bold** for emphasis.") };

      let minItems = 1;
      let maxItems = limit;

      if (items.length > 0 && items[0].text) {
        // Pre-defined item templates — LLM fills in values
        minItems = items.length;
        maxItems = items.length;
      }

      return {
        type: "object",
        properties: {
          items: {
            type: "array",
            description: minItems === maxItems ? undefined : arrayDesc,
            minItems,
            maxItems,
            items: { type: "object", properties: itemProps, required: ["text"], additionalProperties: false }
          }
        },
        required: ["items"],
        additionalProperties: false
      };
    },

    buildShapeDescription(block) {
      const style = block.style || "bullet";
      return `{ "items": [{"text": "<string>"}, ...] }  // ${style} list`;
    },

    isBlockLevelTarget() { return true; },
    skipFromPinSchema() { return false; },
    isCodeDerived() { return false; },
    collectHints() { return []; },
    buildPromptSupplement() { return ""; },
    postProcess(data) { return data; },
  },

  renderer: null, // wired by ui/src/blockRegistryInit.js

  editor: {
    icon: "list",
    category: "text",
    defaultTemplate: { type: "list", style: "bullet", item_limit: 10 },
    configFields: [
      { name: "style", type: "select", label: "List style", options: ["bullet", "numbered"], defaultValue: "bullet" },
      { name: "item_limit", type: "number", label: "Max items", defaultValue: 10 },
    ],
  },
};
